import * as Yup from "yup";

const useKmcForms = function (fields, schema, veeValidate) {

    const applyFieldsConstraints = function (obj, fields) {
        // debugger
        for (const [key, value] of Object.entries(obj)) {
            if (!fields.hasOwnProperty(key)) return

            const field = fields[key]

            if (field.hasOwnProperty('fields')) {
                const innerSchema = obj[key]['innerType']['fields']
                applyFieldsConstraints(innerSchema, field['fields'])
            }


            if (field['minValue']) {
                obj[key] = obj[key].min(parseFloat(field['minValue']))
            }

            if (field['maxValue']) {
                obj[key] = obj[key].max(parseFloat(field['maxValue']))
            }

            if (field['minLength']) {
                obj[key] = obj[key].min(parseFloat(field['minLength']));

                if (obj[key].type === 'string' && field['minLength'] === 1) {
                    obj[key].tests.filter(test => {
                        if (test.OPTIONS.message === 'Must be at least ${min} characters long') {
                            test.OPTIONS.message = 'Must be at least 1 character long';
                            return true;
                        }

                        return false;
                    });
                }
            }

            if (field['maxLength']) {
                obj[key] = obj[key].max(parseFloat(field['maxLength']))
            }

            if (field['options'] && field['options'].length) {
                const optionValues = field['options'].map(v => v.value)
                obj[key].oneOf(optionValues);
            }
        }
    }

    const applyDefaultValues = () => {
      for (const [key, value] of Object.entries(fields)) {
        if (value['defaultValue']) {
            veeValidate.setFieldValue(key, value['defaultValue']);
        }
      }
    }

    const setSchema = function (obj) {
        applyFieldsConstraints(obj, fields)
        schema.value = Yup.object(obj)
    }

    return {
        setSchema,
        applyFieldsConstraints,
        applyDefaultValues
    }
}

export {useKmcForms}
